import type { BrandSpecial } from '@iheartjane/data-access';
import type { SmartSortProduct } from '@iheartjane/dm-sdk';
import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import type { QualifyingStatusEnum } from '@iheartjane/types';
import { useCallback } from 'react';

import type { AlgoliaProduct } from '@jane/search/data-access';
import type { MenuProduct } from '@jane/shared/types';

import type { WeightFilterCartProduct } from './MenuBrandSpecialDetail.util';
import {
  filterProductsByWeight,
  shouldShowWeight,
} from './MenuBrandSpecialDetail.util';

interface UseWeightFilters {
  cartProducts: readonly WeightFilterCartProduct[];
  currentSpecial?: BrandSpecial;
  qualifyingStatus?: QualifyingStatusEnum;
}
export const useWeightFilters = ({
  cartProducts,
  currentSpecial,
  qualifyingStatus,
}: UseWeightFilters) => {
  const multipleConditions = useFlag(FLAGS.c3MultipleConditionSpecials);
  const weightFilter = useCallback(
    (weight: string, product: MenuProduct | AlgoliaProduct) =>
      shouldShowWeight({
        currentSpecial,
        cartProducts,
        multipleConditions,
        qualifyingStatus,
      })(weight, product),
    [currentSpecial, cartProducts, multipleConditions, qualifyingStatus]
  );

  const additionalProductFilter = useCallback(
    (products: SmartSortProduct<AlgoliaProduct>[]) => {
      return filterProductsByWeight({
        cartProducts: cartProducts,
        currentSpecial,
        multipleConditions,
        products,
        qualifyingStatus,
      });
    },
    [cartProducts, currentSpecial, multipleConditions, qualifyingStatus]
  );

  return {
    additionalProductFilter,
    weightFilter,
  };
};
